import { Injectable } from "@angular/core";
import { TypeAheadBasicServiceType } from "./typeahead-basic.service.type";
@Injectable()
export class TypeAheadBasicService implements TypeAheadBasicServiceType {
    model: any = {};
}
